export default __webpack_public_path__ + "static/assets/a7102d5c3483d79f2cb141785f892faf.png";